import { CapacitorHttp } from '@capacitor/core'

const baseURL = process.env.VUE_APP_API_URL

const addAuthHeader = (options) => {
  const token = sessionStorage.getItem('token')
  if (token) {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    }
  }
  return options
}

const toPlain = data => data === undefined ? undefined : JSON.parse(JSON.stringify(data))

const handleResponse = async (promise) => {
  try {
    const response = await promise

    // CapacitorHttp doesn't throw errors for non-2xx status codes
    // So we need to check the status and throw manually
    if (response.status >= 400) {
      // Handle 401 specially
      if (response.status === 401) {
        console.log('[AUTH] Unauthorized (401) - Session expired:', {
          url: response.url,
          timestamp: new Date().toISOString()
        })
        // Clear all session data
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('isCustomer')
        sessionStorage.removeItem('isAdmin')
        sessionStorage.removeItem('name')
        sessionStorage.removeItem('isConfidant')
        sessionStorage.removeItem('required2FA')

        // Redirect to login instead of reload
        if (window.location.pathname !== '/login') {
          window.location.href = '/login'
        }
        return
      }

      // Throw error for other 4xx/5xx responses
      const error = new Error('HTTP Error')
      error.response = response
      error.status = response.status
      throw error
    }

    return { data: response.data, status: response.status, headers: response.headers }
  } catch (error) {
    throw error
  }
}

const http = {
  async get(url, config = {}) {
    const options = addAuthHeader({
      url: `${baseURL}${url}`,
      headers: {
        'Accept': 'application/json',
        ...config.headers || {},
      },
      params: config.params,
    })
    return handleResponse(CapacitorHttp.get(options))
  },

  async post(url, data, config = {}) {
    const options = addAuthHeader({
      url: `${baseURL}${url}`,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        ...config.headers || {},
      },
      data: toPlain(data),
    })
    return handleResponse(CapacitorHttp.post(options))
  },

  async put(url, data, config = {}) {
    const options = addAuthHeader({
      url: `${baseURL}${url}`,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        ...config.headers || {},
      },
      data: toPlain(data),
    })
    return handleResponse(CapacitorHttp.put(options))
  },

  async delete(url, config = {}) {
    const options = addAuthHeader({
      url: `${baseURL}${url}`,
      headers: {
        'Accept': 'application/json',
        ...config.headers || {},
      },
    })
    return handleResponse(CapacitorHttp.delete(options))
  },
}

export default http
